import styled from 'styled-components';
import * as Material  from '@material-ui/core';
import * as Parent from '../styles';

export const  DeclaracaoSubtitle = styled.p`
    font-weight: bold;
    padding-top: 22px;
`;

export const ModalBody = styled.div`
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    position: absolute;
    width: 1000px;
    max-width: 90%;
    background-color: white;
    -webkit-box-shadow: 5px 5px 15px 5px #000000; 
    box-shadow: 5px 5px 15px 5px #000000;
    -webkit-border-radius: 10px;
    -moz-border-radius: 10px;
    border-radius: 10px;
    padding: min(20px, 4%) min(85px, 4%);
`;

export const ModalCloseButton = styled(Material.Button)`
    position: absolute;
    top: 16px;
    right: min(15px,5%);
    -webkit-border-radius: 8px;
    -moz-border-radius: 8px;
    border-radius: 8px;
    height: 30px;
    width: 30px;
    min-width: 30px;
    max-width: 30px;
    overflow: visible;
    display: block;
    line-height: 6px;
    padding: 0;
    text-align: center;
`;

export const ModalSessionTitle = styled(Parent.SessionTitle)`
    margin-top: 30px;
`

export const BoxButtonModal = styled.div`
    width: min(400px, 100%);
`;